import { Injectable } from '@angular/core';
import { MSelector } from '@argalis-apps/models';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CommunicationConfigService, ConfigService } from '@argalis-apps/angular-global';
import * as TEST from './data-test';
@Injectable({
  providedIn: 'root'
})
export class SelectorService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private communicationConfigService: CommunicationConfigService
  ) {}

  getListGroup(): Observable<MSelector.IFamile_Group_Site[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of();
    } else {
      return this.http.get<MSelector.IFamile_Group_Site[]>(
        `${this.communicationConfigService.getApiUri()}/selector/group-selector`
      );
    }
  }

  getListFamile(): Observable<MSelector.IFamile_Group_Site[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of(TEST.TEST_IFamile_Group);
    } else {
      return this.http.get<MSelector.IFamile_Group_Site[]>(
        `${this.communicationConfigService.getApiUri()}/selector/family-selector`
      );
    }
  }

  getListSector(): Observable<MSelector.ISector[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of(TEST.TEST_ISector);
    } else {
      return this.http.get<MSelector.ISector[]>(
        `${this.communicationConfigService.getApiUri()}/selector/sector-selector`
      );
    }
  }

  getListProduit(): Observable<MSelector.IProduit[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of(TEST.TEST_IProduit);
    } else {
      return this.http.get<MSelector.IProduit[]>(
        `${this.communicationConfigService.getApiUri()}/selector/produit-selector`
      );
    }
  }

  getListStatutSession(): Observable<MSelector.IStatut_Session[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of(TEST.TEST_Sesson);
    } else {
      return this.http.get<MSelector.IStatut_Session[]>(
        `${this.communicationConfigService.getApiUri()}/selector/status-session-selector`
      );
    }
  }

  getListSite(): Observable<MSelector.IFamile_Group_Site[]> {
    return of(TEST.TEST_SITE);
    // TODO: A changer pour la production
    /*if (true === true) {
      return of(TEST.TEST_SITE);
    } else {
      return of(TEST.TEST_SITE);
      //TODO change URL
      // return this.http.get<MSelector.IFamile_Group_Site[]>(`https://back.argalis.fr/api/clientstat/site/1`);
    }*/
  }

  getTypeOfApprenantSelector(): Observable<MSelector.ITypeApprenantSelector[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of(TEST.TEST_TYPE_APPRENANT);
    } else {
      return this.http.get<MSelector.ITypeApprenantSelector[]>(
        `${this.communicationConfigService.getApiUri()}/selector/type-apprenant-selector`
      );
    }
  }
  getIntervenantDepartementSelector(): Observable<MSelector.IIntervenantDepartementsSelector[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of(TEST.TEST_INTERVEANANTDEPARTEMEN);
    } else {
      return this.http.get<MSelector.IIntervenantDepartementsSelector[]>(
        `${this.communicationConfigService.getApiUri()}/selector/intervenant-departements-selector`
      );
    }
  }

  getPays(): Observable<MSelector.IPays[]> {
    return this.http.get<MSelector.IPays[]>(`${this.communicationConfigService.getApiUri()}/selector/pays`);
  }

  getMotifAbsenceSelector(): Observable<MSelector.IMotifAbsenceSelector[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of(TEST.TEST_MOTIF_ABSENCE_SELECTOR);
    } else {
      return this.http.get<MSelector.IMotifAbsenceSelector[]>(
        `${this.communicationConfigService.getApiUri()}/selector/motif-absence-selector`
      );
    }
  }
}
